export default __webpack_public_path__ + "assets/images/music-player.png";